module.exports = __webpack_public_path__ + "img/1557614079736094722.74ebdc34.png";